import Vue from 'vue'
import Vuex from 'vuex'
import transportModes from '@/store/transportModes'
import { getToken } from '@/utils/auth'
import createPersistedState from 'vuex-persistedstate';
import mutations from './mutations'
import getters from './getters'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        auth: {
            token: getToken(),
        },
        user: null,
        form: {
            origin: '',
            destination: '',
            out_time: null,
            arrive_time: null,
            return_time: null,
            has_car_access: true,
        },
        journeyFilter: 'all',
        journeySorting: 'duration',
        journeyTypeFilter: false,
        journeyResults: [],
        journeyType: 'single',
        currentLocation: null,
        results: [],
        activeCampaign: null,
        activeCampaignImpression: null,
        campaignImpressions: [],
        isLoading: true,
        currentJourney: null,
        searchQuery: null,
        errors: {
        },
        defaultError: false,
        defaultSuccess: false,
        resultFilter: {
            selected: 'all',
        },
        resultSort: {
            selected: 'emissions',
        },
        mapFilter: {
            selected: 'none',
        },
        mapping: {
            transportModes,
        },
        resultQueryStages: [],
        selectedMultipleResultStages: [],
    },
    mutations,
    actions,
    getters,
    plugins: [
        createPersistedState({
            paths: ['campaignImpressions'],
        }),
    ],
})
